import axios from "axios";

export default axios.create({
  baseURL: process.env.NODE_ENV == 'production' ? '/service/api' : "http://localhost:8000/api",
  headers: {
    "Content-type": "application/json"
  }
});



// WEBPACK FOOTER //
// ./src/http-common.js